import { Component, OnInit } from '@angular/core';
import { RechargesService } from '../../services/recharges/recharges.service';

import { ToastComponent } from '../toast/toast.component';
import { MatSnackBar } from '@angular/material';

@Component({
    selector: 'app-recharge-history',
    templateUrl: './recharge-history.component.html',
    styleUrls: ['./recharge-history.component.scss']
})
export class RechargeHistoryComponent implements OnInit {

    public recharges = [];
    public loading = true;

    constructor(
        public rechargesService: RechargesService,
        private snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        this.loading = true;
        this.rechargesService.list().subscribe((res)=>{
            if(res.success){
                this.recharges = res.recharges;
            }else{
                this.snackBar.openFromComponent(ToastComponent, {
                    data: res.msg
                });
            }
            this.loading = false;
        })
    }

}
